/**
 * @generated SignedSource<<a55c15067cf85d7c1cbe95d2da92f9e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AgenticWorkerResultState = "NEEDS_REVIEW" | "DONE" | "DELETED" | "%future added value";
export type AgenticWorkerRowType = "PROJECT_BILLING_ROW" | "RETAINER_PERIOD_ROW" | "%future added value";
export type AcceptAgenticWorkerResultInput = {
  id: string;
  rowType?: AgenticWorkerRowType | null;
  rowId?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type AcceptAgenticWorkerResultMutation$variables = {
  input: AcceptAgenticWorkerResultInput;
};
export type AcceptAgenticWorkerResultMutation$data = {
  readonly acceptAgenticWorkerResult: {
    readonly accepted: boolean;
    readonly refusalReason: string | null;
    readonly result: {
      readonly id: string;
      readonly state: AgenticWorkerResultState;
      readonly hidden: boolean;
      readonly actedAt: string | null;
      readonly actedBy: {
        readonly fullName: string | null;
      } | null;
    } | null;
  } | null;
};
export type AcceptAgenticWorkerResultMutation = {
  variables: AcceptAgenticWorkerResultMutation$variables;
  response: AcceptAgenticWorkerResultMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AcceptAgenticWorkerResultPayload",
    "kind": "LinkedField",
    "name": "acceptAgenticWorkerResult",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accepted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refusalReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AgenticWorkerResult",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hidden",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaRunAuthor",
            "kind": "LinkedField",
            "name": "actedBy",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptAgenticWorkerResultMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptAgenticWorkerResultMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "92fae6bf2be99c04e2de226f705ccc7f",
    "id": null,
    "metadata": {},
    "name": "AcceptAgenticWorkerResultMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptAgenticWorkerResultMutation(\n  $input: AcceptAgenticWorkerResultInput!\n) {\n  acceptAgenticWorkerResult(input: $input) {\n    accepted\n    refusalReason\n    result {\n      id\n      state\n      hidden\n      actedAt\n      actedBy {\n        fullName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f384fffa6f8caab2b4cbad7bfc961d4";

export default node;
